import React, { useState, useRef, useEffect } from 'react';
import './Input.css';

function Input({
  type = 'text',
  label,
  value,
  onChange,
  placeholder,
  icon: Icon,
  error,
  required,
  autoComplete,
  id,
  className = '',
  ...props
}) {
  const [isFocused, setIsFocused] = useState(false);
  const [hasValue, setHasValue] = useState(!!value);
  const inputRef = useRef(null);

  useEffect(() => {
    setHasValue(!!value);
  }, [value]);

  const handleFocus = () => setIsFocused(true);
  const handleBlur = () => setIsFocused(false);

  const handleChange = (e) => {
    setHasValue(!!e.target.value);
    if (onChange) onChange(e);
  };

  return (
    <div className={`modern-input-wrapper ${className} ${error ? 'has-error' : ''}`}>
      <div className={`modern-input-container ${isFocused ? 'focused' : ''} ${hasValue ? 'has-value' : ''}`}>
        {Icon && (
          <div className="modern-input-icon">
            <Icon />
          </div>
        )}
        <div className="modern-input-field-wrapper">
          <input
            ref={inputRef}
            id={id}
            type={type}
            className="modern-input-field"
            value={value}
            onChange={handleChange}
            onFocus={handleFocus}
            onBlur={handleBlur}
            placeholder={isFocused ? placeholder : ''}
            autoComplete={autoComplete}
            required={required}
            {...props}
          />
          {label && (
            <label 
              htmlFor={id} 
              className={`modern-input-label ${isFocused || hasValue ? 'floating' : ''}`}
            >
              {label}
              {required && <span className="required-star">*</span>}
            </label>
          )}
        </div>
      </div>
      {error && <div className="modern-input-error">{error}</div>}
    </div>
  );
}

export default Input;